let backendHost;

const hostname = window && window.location && window.location.hostname;

if (/^app-stage/.test(hostname)) {
    backendHost = 'https://api-stage.nova.edu/appcentral/OracleBanner';
} else if (/^fldvt/.test(hostname)) {
    backendHost = 'https://fldvt-apinet01.ad.nova.edu/appcentral/OracleBanner';
} else if (/^fldvd/.test(hostname)) {
    backendHost = 'http://fldvd-apinet01.ad.nova.edu/appcentral/OracleBanner';
} else if (/^fldvs/.test(hostname)) {
    backendHost = 'https://api-stage.nova.edu/appcentral/OracleBanner';
} else if (/^app/.test(hostname)) {
    backendHost = 'https://api.nova.edu/appcentral/OracleBanner';
} else {
    backendHost = process.env.REACT_APP_BACKEND_HOST || 'http://localhost:8540/oraclebanner';
}

export const API_ROOT = `${backendHost}/`;
